module.exports = __webpack_public_path__ + "img/8.83a8d79c.jpg";